import {
  getFaqArticleFilterRepo, getFaqArticleListRepo, getFaqQuestionKeywordsRepo, getFaqEditPageCommonRepo, deleteFaqQuestionAndMappingRepo, postFaqEditPageCommonRepo,
  getFaqExamFilterRepo, getFaqCollegeFacetListRepo, getFaqCollegeFacetFilterRepo, getFaqExamListRepo, getFaqCollegeFilterRepo, getFaqCollegeListRepo,
  postFaqGenerateCommonRepo, postFaqEntityLockRepo, postClearCacheRepo
} from "../repositories/faq/index";
import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";
const faqSlice = createSlice({
  name: "faqReducer",
  initialState: {
    faqArticleTitleLoading: false,
    faqArticleTitleData: null,
    faqArticleTitleError: null,

    faqArticleMainCategoryLoading: false,
    faqArticleMainCategoryData: null,
    faqArticleMainCategoryError: null,

    faqArticleSubCategoryLoading: false,
    faqArticleSubCategoryData: null,
    faqArticleSSubCategoryError: null,

    faqArticleListLoading: false,
    faqArticleListData: null,
    faqArticleListError: null,

    faqQuestionEntityTypeLoading: false,
    faqQuestionEntityTypeData: null,
    faqQuestionEntityTypeError: null,

    faqQuestionKeywordsLoading: false,
    faqQuestionKeywordsData: null,
    faqQuestionKeywordsError: null,

    faqEditPageCommonLoading: false,
    faqEditPageCommonData: null,
    faqEditPageCommonError: null,

    faqMappedHeadingLoading: false,
    faqMappedHeadingData: null,
    faqMappedHeadingError: null,

    postFaqEditPageCommonLoading: false,
    postFaqEditPageCommonData: null,
    postFaqEditPageCommonError: null,

    faqQuestionAndMappingLoading: false,
    faqQuestionAndMappingData: null,
    faqQuestionAndMappingError: null,

    // AI FAQ EXAM PANEL
    faqExamNameLoading: false,
    faqExamNameData: null,
    faqExamNameError: null,

    faqExamDomainLoading: false,
    faqExamDomainData: null,
    faqExamDomainError: null,

    faqExamLevelLoading: false,
    faqExamLevelData: null,
    faqExamLevelError: null,

    faqExamListLoading: false,
    faqExamListData: null,
    faqExamListError: null,

    faqCollegeFacetListLoading: false,
    faqCollegeFacetListData: null,
    faqCollegeFacetListError: null,

    faqCollegeFacetDomainFilterLoading: false,
    faqCollegeFacetDomainFilterData: null,
    faqCollegeFacetDomainFilterError: null,

    faqCollegeFacetH1TitleFilterLoading: false,
    faqCollegeFacetH1TitleFilterData: null,
    faqCollegeFacetH1TitleFilterError: null,

    faqCollegeFacetPageUrlFilterLoading: false,
    faqCollegeFacetPageUrlFilterData: null,
    faqCollegeFacetPageUrlFilterError: null,

    //ai generate modal
    faqGenerateHeadingLoading: false,
    faqGenerateHeadingData: null,
    faqGenerateHeadingError: null,

    faqGenerateQuestionLoading: false,
    faqGenerateQuestionData: null,
    faqGenerateQuestionError: null,

    faqGenerateAnswersLoading: false,
    faqGenerateAnswersData: null,
    faqGenerateAnswersError: null,

    faqRegenerateQuestionLoading: false,
    faqRegenerateQuestionData: null,
    faqRegenerateQuestionError: null,

    faqRegenerateAnswersLoading: false,
    faqRegenerateAnswersData: null,
    faqRegenerateAnswersError: null,

    faqGenerateAnswerModificationLoading: false,
    faqGenerateAnswerModificationData: null,
    faqGenerateAnswerModificationError: null,

    faqEntityLockLoading: false,
    faqEntityLockData: null,
    faqEntityLockError: null,

    faqCollegeNameLoading: false,
    faqCollegeNameData: null,
    faqCollegeNameError: null,

    faqCollegePageTypeLoading: false,
    faqCollegePageTypeData: null,
    faqCollegePageTypeError: null,

    faqCollegeListLoading: false,
    faqCollegeListData: null,
    faqCollegeListError: null,

    postClearCacheIsLoading:null,
    postClearedCache:null,
    postClearCacheError:null,

    message:null,

  },
  reducers: {

    getFaqArticleTitleLoading(state, action) {
      return {
        ...state,
        faqArticleTitleLoading: true,
      };
    },
    getFaqArticleTitleSuccess(state, action) {
      return {
        ...state,
        faqArticleTitleLoading: false,
        faqArticleTitleData: action.payload,
      };
    },

    getFaqArticleTitleFailure(state, action) {
      return {
        ...state,
        faqArticleTitleLoading: false,
        faqArticleTitleError: action.payload,
      };
    },

    clearArticleTitleDataResponse(state, action) {
      return {
        ...state,
        faqArticleTitleData: null,
      }
    },


    getFaqArticleMainCategoryLoading(state, action) {
      return {
        ...state,
        faqArticleMainCategoryLoading: true,
      };
    },
    getFaqArticleMainCategorySuccess(state, action) {
      return {
        ...state,
        faqArticleMainCategoryLoading: false,
        faqArticleMainCategoryData: action.payload,
      };
    },

    getFaqArticleMainCategoryFailure(state, action) {
      return {
        ...state,
        faqArticleMainCategoryLoading: false,
        faqArticleMainCategoryError: action.payload,
      };
    },

    clearArticleMainCategoryDataResponse(state, action) {
      return {
        ...state,
        faqArticleMainCategoryData: null,
      }
    },


    getFaqArticleSubCategoryLoading(state, action) {
      return {
        ...state,
        faqArticleSubCategoryLoading: true,
      };
    },
    getFaqArticleSubCategorySuccess(state, action) {
      return {
        ...state,
        faqArticleSubCategoryLoading: false,
        faqArticleSubCategoryData: action.payload,
      };
    },

    getFaqArticleSubCategoryFailure(state, action) {
      return {
        ...state,
        faqArticleSubCategoryLoading: false,
        faqArticleSubCategoryError: action.payload,
      };
    },


    clearArticleSubCategoryDataResponse(state, action) {
      return {
        ...state,
        faqArticleSubCategoryData: null,
      }
    },

    getFaqArticleListLoading(state, action) {
      return {
        ...state,
        faqArticleListLoading: true,
      };
    },
    getFaqArticleListSuccess(state, action) {
      return {
        ...state,
        faqArticleListLoading: false,
        faqArticleListData: action.payload,
      };
    },
    getFaqArticleListFailure(state, action) {
      return {
        ...state,
        faqArticleListLoading: false,
        faqArticleListError: action.payload,
      };
    },
    clearFaqArticleListResponse(state, action) {
      return {
        ...state,
        faqArticleListError: null,
      };
    },


    getFaqQuestionEntityTypeLoading(state, action) {
      return {
        ...state,
        faqQuestionEntityTypeLoading: true,
      };
    },
    getFaqQuestionEntityTypeSuccess(state, action) {
      return {
        ...state,
        faqQuestionEntityTypeLoading: false,
        faqQuestionEntityTypeData: action.payload,
      };
    },
    getFaqQuestionEntityTypeFailure(state, action) {
      return {
        ...state,
        faqQuestionEntityTypeLoading: false,
        faqQuestionEntityTypeError: action.payload,
      };
    },

    getFaqQuestionKeywordsLoading(state, action) {
      return {
        ...state,
        faqQuestionKeywordsLoading: true,
      };
    },
    getFaqQuestionKeywordsSuccess(state, action) {
      return {
        ...state,
        faqQuestionKeywordsLoading: false,
        faqQuestionKeywordsData: action.payload,
      };
    },
    getFaqQuestionKeywordsFailure(state, action) {
      return {
        ...state,
        faqQuestionKeywordsLoading: false,
        faqQuestionKeywordsError: action.payload,
      };
    },
    postFaqMappedHeadingLoading(state, action) {
      return {
        ...state,
        faqMappedHeadingLoading: true,
      };
    },
    postFaqMappedHeadingSuccess(state, action) {
      return {
        ...state,
        faqMappedHeadingLoading: false,
        faqMappedHeadingData: action.payload,
      };
    },

    postFaqMappedHeadingFailure(state, action) {
      return {
        ...state,
        faqMappedHeadingLoading: false,
        faqMappedHeadingError: action.payload,
      };
    },
    clearPostFaqMappedHeadingResponse(state, action) {
      return {
        ...state,
        faqMappedHeadingData: null,
      };
    },

    getFaqEditPageCommonLoading(state, action) {
      return {
        ...state,
        faqEditPageCommonLoading: true,
      };
    },
    getFaqEditPageCommonSuccess(state, action) {
      return {
        ...state,
        faqEditPageCommonLoading: false,
        faqEditPageCommonData: action.payload,
      };
    },
    getFaqEditPageCommonFailure(state, action) {
      return {
        ...state,
        faqEditPageCommonLoading: false,
        faqEditPageCommonError: action.payload,
      };
    },

    deleteFaqQuestionAndMappingLoading(state, action) {
      return {
        ...state,
        faqQuestionAndMappingLoading: true,
      };
    },
    deleteFaqQuestionAndMappingSuccess(state, action) {
      return {
        ...state,
        faqQuestionAndMappingLoading: false,
        faqQuestionAndMappingData: action.payload,
      };
    },
    deleteFaqQuestionAndMappingFailure(state, action) {
      return {
        ...state,
        faqQuestionAndMappingLoading: false,
        faqQuestionAndMappingError: action.payload,
      };
    },
    clearDeleteFaqQuestionAndMappingResponse(state, action) {
      return {
        ...state,
        faqQuestionAndMappingData: null,
        faqQuestionAndMappingError: null,
      };
    },
    postFaqPageCommonLoading(state, action) {
      return {
        ...state,
        postFaqEditPageCommonLoading: true,
      };
    },
    postFaqPageCommonSuccess(state, action) {
      return {
        ...state,
        postFaqEditPageCommonLoading: false,
        postFaqEditPageCommonData: action.payload,
      };
    },
    postFaqPageCommonFailure(state, action) {
      return {
        ...state,
        postFaqEditPageCommonLoading: false,
        postFaqEditPageCommonError: action.payload,
      };
    },

    clearPostFaqPageCommonSuccess(state, action) {
      return {
        ...state,
        postFaqEditPageCommonError: null,
        postFaqEditPageCommonData: null,
      };
    },

    // AI FAQ EXAM PANEL
    getFaqExamNameLoading(state, action) {
      return {
        ...state,
        faqExamNameLoading: true,
      };
    },
    getFaqExamNameSuccess(state, action) {
      return {
        ...state,
        faqExamNameLoading: false,
        faqExamNameData: action.payload,
      };
    },

    getFaqExamNameFailure(state, action) {
      return {
        ...state,
        faqExamNameLoading: false,
        faqExamNameError: action.payload,
      };
    },
    clearFaqExamNameSuccessResponse(state, action) {
      return {
        ...state,
        faqExamNameData: null,
      };
    },

    getFaqExamDomainLoading(state, action) {
      return {
        ...state,
        faqExamDomainLoading: true,
      };
    },
    getFaqExamDomainSuccess(state, action) {
      return {
        ...state,
        faqExamDomainLoading: false,
        faqExamDomainData: action.payload,
      };
    },

    getFaqExamDomainFailure(state, action) {
      return {
        ...state,
        faqExamDomainLoading: false,
        faqExamDomainError: action.payload,
      };
    },
    clearFaqExamDomainSuccessResponse(state, action) {
      return {
        ...state,
        faqExamDomainData: null,
      };
    },


    getFaqExamLevelLoading(state, action) {
      return {
        ...state,
        faqExamLevelLoading: true,
      };
    },
    getFaqExamLevelSuccess(state, action) {
      return {
        ...state,
        faqExamLevelLoading: false,
        faqExamLevelData: action.payload,
      };
    },

    getFaqExamLevelFailure(state, action) {
      return {
        ...state,
        faqExamLevelLoading: false,
        faqExamLevelError: action.payload,
      };
    },
    clearFaqExamLevelSuccessResponse(state, action) {
      return {
        ...state,
        faqExamLevelData: null,
      };
    },

    getFaqExamListLoading(state, action) {
      return {
        ...state,
        faqExamListLoading: true,
      };
    },
    getFaqExamListSuccess(state, action) {
      return {
        ...state,
        faqExamListLoading: false,
        faqExamListData: action.payload,
      };
    },

    getFaqExamListFailure(state, action) {
      return {
        ...state,
        faqExamListLoading: false,
        faqExamListError: action.payload,
      };
    },
    clearFaqExamListSuccessResponse(state, action) {
      return {
        ...state,
        faqExamListError: null,
      };
    },
    getFaqCollegeFacetListLoading(state, action) {
      return {
        ...state,
        faqCollegeFacetListLoading: true,
      };
    },
    getFaqCollegeFacetListSuccess(state, action) {
      return {
        ...state,
        faqCollegeFacetListLoading: false,
        faqCollegeFacetListData: action.payload,
      };
    },

    getFaqCollegeFacetListFailure(state, action) {
      return {
        ...state,
        faqCollegeFacetListLoading: false,
        faqCollegeFacetListError: action.payload,
      };
    },
    clearFaqCollegeFacetListSuccessResponse(state, action) {
      return {
        ...state,
        faqCollegeFacetListError: null,
      };
    },

    getFaqCollegeFacetDomainFilterLoading(state, action) {
      return {
        ...state,
        faqCollegeFacetDomainFilterLoading: true,
      };
    },
    getFaqCollegeFacetDomainFilterSuccess(state, action) {
      return {
        ...state,
        faqCollegeFacetDomainFilterLoading: false,
        faqCollegeFacetDomainFilterData: action.payload,
      };
    },

    getFaqCollegeFacetDomainFilterFailure(state, action) {
      return {
        ...state,
        faqCollegeFacetDomainFilterLoading: false,
        faqCollegeFacetDomainFilterError: action.payload,
      };
    },
    clearFaqCollegeFacetDomainFilterSuccessResponse(state, action) {
      return {
        ...state,
        faqCollegeFacetDomainFilterData: null,
      };
    },

    getFaqCollegeFacetH1TitleFilterLoading(state, action) {
      return {
        ...state,
        faqCollegeFacetH1TitleFilterLoading: true,
      };
    },
    getFaqCollegeFacetH1TitleFilterSuccess(state, action) {
      return {
        ...state,
        faqCollegeFacetH1TitleFilterLoading: false,
        faqCollegeFacetH1TitleFilterData: action.payload,
      };
    },

    getFaqCollegeFacetH1TitleFilterFailure(state, action) {
      return {
        ...state,
        faqCollegeFacetH1TitleFilterLoading: false,
        faqCollegeFacetH1TitleFilterError: action.payload,
      };
    },
    clearFaqCollegeFacetH1TitleFilterSuccessResponse(state, action) {
      return {
        ...state,
        faqCollegeFacetH1TitleFilterData: null,
      };
    },

    getFaqCollegeFacetPageUrlFilterLoading(state, action) {
      return {
        ...state,
        faqCollegeFacetPageUrlFilterLoading: true,
      };
    },
    getFaqCollegeFacetPageUrlFilterSuccess(state, action) {
      return {
        ...state,
        faqCollegeFacetPageUrlFilterLoading: false,
        faqCollegeFacetPageUrlFilterData: action.payload,
      };
    },

    getFaqCollegeFacetPageUrlFilterFailure(state, action) {
      return {
        ...state,
        faqCollegeFacetPageUrlFilterLoading: false,
        faqCollegeFacetPageUrlFilterError: action.payload,
      };
    },
    clearFaqCollegeFacetH1TitleFilterSuccessResponse(state, action) {
      return {
        ...state,
        faqCollegeFacetPageUrlFilterData: null,
      };
    },

    postFaqGenerateHeadingLoading(state, action) {
      return {
        ...state,
        faqGenerateHeadingLoading: true,
      };
    },
    postFaqGenerateHeadingSuccess(state, action) {
      return {
        ...state,
        faqGenerateHeadingLoading: false,
        faqGenerateHeadingData: action.payload,
      };
    },

    postFaqGenerateHeadingFailure(state, action) {
      return {
        ...state,
        faqGenerateHeadingLoading: false,
        faqGenerateHeadingError: action.payload,
      };
    },
    clearPostFaqGenerateHeadingResponse(state, action) {
      return {
        ...state,
        faqGenerateHeadingData: null,
        // faqGenerateHeadingError: null,
        faqGenerateHeadingLoading: false,
      };
    },

    postFaqGenerateQuestionLoading(state, action) {
      return {
        ...state,
        faqGenerateQuestionLoading: true,
      };
    },
    postFaqGenerateQuestionSuccess(state, action) {
      return {
        ...state,
        faqGenerateQuestionLoading: false,
        faqGenerateQuestionData: action.payload,
        faqGenerateQuestionError: null,
      };
    },

    postFaqGenerateQuestionFailure(state, action) {
      return {
        ...state,
        faqGenerateQuestionLoading: false,
        faqGenerateQuestionError: action.payload,
      };
    },
    clearPostFaqGenerateQuestionResponse(state, action) {
      return {
        ...state,
        faqGenerateQuestionData: null,
        faqGenerateQuestionError: null,
        faqGenerateQuestionLoading: false,
      };
    },

    postFaqGenerateAnswersLoading(state, action) {
      return {
        ...state,
        faqGenerateAnswersLoading: true,
      };
    },
    postFaqGenerateAnswersSuccess(state, action) {
      return {
        ...state,
        faqGenerateAnswersLoading: false,
        faqGenerateAnswersData: action.payload,
      };
    },

    postFaqGenerateAnswersFailure(state, action) {
      return {
        ...state,
        faqGenerateAnswersLoading: false,
        faqGenerateAnswersError: action.payload,
      };
    },
    clearPostFaqGenerateAnswersResponse(state, action) {
      return {
        ...state,
        faqGenerateAnswersData: null,
        // faqGenerateAnswersError: null,
        faqGenerateAnswersLoading: false,
      };
    },
    clearPostFaqGenerateAnswersErrorResponse(state, action) {
      return {
        ...state,
        faqGenerateAnswersError: null,
      };
    },

    postFaqRegenerateQuestionLoading(state, action) {
      return {
        ...state,
        faqRegenerateQuestionLoading: true,
      };
    },
    postFaqRegenerateQuestionSuccess(state, action) {
      return {
        ...state,
        faqRegenerateQuestionLoading: false,
        faqRegenerateQuestionData: action.payload,
      };
    },

    postFaqRegenerateQuestionFailure(state, action) {
      return {
        ...state,
        faqRegenerateQuestionLoading: false,
        faqRegenerateQuestionError: action.payload,
      };
    },
    clearPostFaqRegenerateQuestionResponse(state, action) {
      return {
        ...state,
        faqRegenerateQuestionData: null,
      };
    },

    postFaqRegenerateAnswersLoading(state, action) {
      return {
        ...state,
        faqRegenerateAnswersLoading: true,
      };
    },
    postFaqRegenerateAnswersSuccess(state, action) {
      return {
        ...state,
        faqRegenerateAnswersLoading: false,
        faqRegenerateAnswersData: action.payload,
      };
    },

    postFaqRegenerateAnswersFailure(state, action) {
      return {
        ...state,
        faqRegenerateAnswersLoading: false,
        faqRegenerateAnswersError: action.payload,
      };
    },
    clearPostFaqRegenerateAnswersResponse(state, action) {
      return {
        ...state,
        faqRegenerateAnswersData: null,
      };
    },


    postFaqGenerateAnswerModificationLoading(state, action) {
      return {
        ...state,
        faqGenerateAnswerModificationLoading: true,
      };
    },
    postFaqGenerateAnswerModificationSuccess(state, action) {
      return {
        ...state,
        faqGenerateAnswerModificationLoading: false,
        faqGenerateAnswerModificationData: action.payload,
      };
    },

    postFaqGenerateAnswerModificationFailure(state, action) {
      return {
        ...state,
        faqGenerateAnswerModificationLoading: false,
        faqGenerateAnswerModificationError: action.payload,
      };
    },
    clearPostFaqGenerateAnswerModificationResponse(state, action) {
      return {
        ...state,
        faqGenerateAnswerModificationData: null,
      };
    },

    postFaqEntityLockLoading(state, action) {
      return {
        ...state,
        faqEntityLockLoading: true,
      };
    },
    postFaqEntityLockSuccess(state, action) {
      return {
        ...state,
        faqEntityLockLoading: false,
        faqEntityLockData: action.payload,
      };
    },

    postFaqEntityLockFailure(state, action) {
      return {
        ...state,
        faqEntityLockLoading: false,
        faqEntityLockError: action.payload,
      };
    },
    clearPostEntityLockFaqResponse(state, action) {
      return {
        ...state,
        faqEntityLockData: null,
      };
    },


    getFaqCollegeNameLoading(state, action) {
      return {
        ...state,
        faqCollegeNameLoading: true,
      };
    },
    getFaqCollegeNameSuccess(state, action) {
      return {
        ...state,
        faqCollegeNameLoading: false,
        faqCollegeNameData: action.payload,
      };
    },

    getFaqCollegeNameFailure(state, action) {
      return {
        ...state,
        faqCollegeNameLoading: false,
        faqCollegeNameError: action.payload,
      };
    },

    clearFaqCollegeNameResponse(state, action) {
      return {
        ...state,
        faqCollegeNameData: null,
      }
    },

    getFaqCollegePageTypeLoading(state, action) {
      return {
        ...state,
        faqCollegePageTypeLoading: true,
      };
    },
    getFaqCollegePageTypeSuccess(state, action) {
      return {
        ...state,
        faqCollegePageTypeLoading: false,
        faqCollegePageTypeData: action.payload,
      };
    },

    getFaqCollegePageTypeFailure(state, action) {
      return {
        ...state,
        faqCollegePageTypeLoading: false,
        faqCollegePageTypeError: action.payload,
      };
    },

    clearFaqCollegePageTypeResponse(state, action) {
      return {
        ...state,
        faqCollegePageTypeData: null,
      }
    },

    getFaqCollegeListLoading(state, action) {
      return {
        ...state,
        faqCollegeListLoading: true,
      };
    },
    getFaqCollegeListSuccess(state, action) {
      return {
        ...state,
        faqCollegeListLoading: false,
        faqCollegeListData: action.payload,
      };
    },

    getFaqCollegeListFailure(state, action) {
      return {
        ...state,
        faqCollegeListLoading: false,
        faqCollegeListError: action.payload,
      };
    },

    clearFaqCollegeListResponse(state, action) {
      return {
        ...state,
        faqCollegeListError: null,
      }
    },

    postClearCacheLoading(state, action) {
      return {
        ...state,
        postClearCacheIsLoading: true,
      };
    },
    postClearCacheSuccess(state, action) {
      return {
        ...state,
        postClearCacheIsLoading: false,
        postClearedCache: action.payload,
        message:'Cache Cleared',
      };
    },

    postClearCacheFailure(state, action) {
      return {
        ...state,
        postClearCacheIsLoading: false,
        postClearCacheError: action.payload,
        message:'Something went wrong',
      };
    },
    clearMessageForCache(state, action) {
      return {
        ...state,
        message:null,
        postClearCacheError:null,
        postClearedCache:null,
      };
    },

    commonClearErrorState(state, action) {
      return {
        ...state,
        faqGenerateHeadingError:null,
        faqGenerateQuestionError:null,
        faqGenerateAnswersError:null,
      };
    },


  },
});

export const {
  getFaqArticleTitleLoading,
  getFaqArticleTitleSuccess,
  getFaqArticleTitleFailure,
  clearArticleTitleDataResponse,

  getFaqArticleMainCategoryLoading,
  getFaqArticleMainCategorySuccess,
  getFaqArticleMainCategoryFailure,
  clearArticleMainCategoryDataResponse,

  getFaqArticleSubCategoryLoading,
  getFaqArticleSubCategorySuccess,
  getFaqArticleSubCategoryFailure,
  clearArticleSubCategoryDataResponse,


  getFaqArticleListLoading,
  getFaqArticleListSuccess,
  getFaqArticleListFailure,
  clearFaqArticleListResponse,


  getFaqQuestionEntityTypeLoading,
  getFaqQuestionEntityTypeSuccess,
  getFaqQuestionEntityTypeFailure,

  getFaqQuestionKeywordsLoading,
  getFaqQuestionKeywordsSuccess,
  getFaqQuestionKeywordsFailure,

  getFaqEditPageCommonLoading,
  getFaqEditPageCommonSuccess,
  getFaqEditPageCommonFailure,

  postFaqMappedHeadingLoading,
  postFaqMappedHeadingSuccess,
  postFaqMappedHeadingFailure,
  clearPostFaqMappedHeadingResponse,

  deleteFaqQuestionAndMappingLoading,
  deleteFaqQuestionAndMappingSuccess,
  deleteFaqQuestionAndMappingFailure,
  clearDeleteFaqQuestionAndMappingResponse,

  postFaqPageCommonLoading,
  postFaqPageCommonSuccess,
  postFaqPageCommonFailure,
  clearPostFaqPageCommonSuccess,

  // AI FAQ EXAM PANEL
  getFaqExamNameLoading,
  getFaqExamNameSuccess,
  getFaqExamNameFailure,
  clearFaqExamNameSuccessResponse,

  getFaqExamDomainLoading,
  getFaqExamDomainSuccess,
  getFaqExamDomainFailure,
  clearFaqExamDomainSuccessResponse,

  getFaqExamLevelLoading,
  getFaqExamLevelSuccess,
  getFaqExamLevelFailure,
  clearFaqExamLevelSuccessResponse,

  getFaqExamListLoading,
  getFaqExamListSuccess,
  getFaqExamListFailure,
  clearFaqExamListSuccessResponse,

  getFaqCollegeFacetListLoading,
  getFaqCollegeFacetListSuccess,
  getFaqCollegeFacetListFailure,
  clearFaqCollegeFacetListSuccessResponse,

  getFaqCollegeFacetDomainFilterLoading,
  getFaqCollegeFacetDomainFilterSuccess,
  getFaqCollegeFacetDomainFilterFailure,
  clearFaqCollegeFacetDomainFilterSuccessResponse,

  getFaqCollegeFacetH1TitleFilterLoading,
  getFaqCollegeFacetH1TitleFilterSuccess,
  getFaqCollegeFacetH1TitleFilterFailure,
  getFaqCollegeFacetH1TitleFilterSuccessResponse,

  getFaqCollegeFacetPageUrlFilterLoading,
  getFaqCollegeFacetPageUrlFilterSuccess,
  getFaqCollegeFacetPageUrlFilterFailure,
  getFaqCollegeFacetPageUrlFilterSuccessResponse,

  postFaqGenerateHeadingLoading,
  postFaqGenerateHeadingSuccess,
  postFaqGenerateHeadingFailure,
  clearPostFaqGenerateHeadingResponse,

  postFaqGenerateQuestionLoading,
  postFaqGenerateQuestionSuccess,
  postFaqGenerateQuestionFailure,
  clearPostFaqGenerateQuestionResponse,

  postFaqGenerateAnswersLoading,
  postFaqGenerateAnswersSuccess,
  postFaqGenerateAnswersFailure,
  clearPostFaqGenerateAnswersResponse,
  clearPostFaqGenerateAnswersErrorResponse,

  postFaqRegenerateQuestionLoading,
  postFaqRegenerateQuestionSuccess,
  postFaqRegenerateQuestionFailure,
  clearPostFaqRegenerateQuestionResponse,

  postFaqRegenerateAnswersLoading,
  postFaqRegenerateAnswersSuccess,
  postFaqRegenerateAnswersFailure,
  clearPostFaqRegenerateAnswersResponse,

  postFaqGenerateAnswerModificationLoading,
  postFaqGenerateAnswerModificationSuccess,
  postFaqGenerateAnswerModificationFailure,
  clearPostFaqGenerateAnswerModificationResponse,

  postFaqEntityLockLoading,
  postFaqEntityLockSuccess,
  postFaqEntityLockFailure,
  clearPostEntityLockFaqResponse,

  getFaqCollegeNameLoading,
  getFaqCollegeNameSuccess,
  getFaqCollegeNameFailure,
  clearFaqCollegeNameResponse,

  getFaqCollegePageTypeLoading,
  getFaqCollegePageTypeSuccess,
  getFaqCollegePageTypeFailure,
  getFaqCollegePageTypeResponse,

  getFaqCollegeListLoading,
  getFaqCollegeListSuccess,
  getFaqCollegeListFailure,
  clearFaqCollegeListResponse,

  postClearCacheLoading,
  postClearCacheSuccess,
  postClearCacheFailure,

  clearMessageForCache,
  commonClearErrorState,

} = faqSlice.actions;

export const getFaqArticleTitle = (params) => {
  return async (dispatch) => {
    dispatch(getFaqArticleTitleLoading());
    await getFaqArticleFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqArticleTitleSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqArticleTitleFailure(error.message));
        }
      });
  };
};

export const getFaqArticleMainCategory = (params) => {
  return async (dispatch) => {
    dispatch(getFaqArticleMainCategoryLoading());
    await getFaqArticleFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqArticleMainCategorySuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqArticleMainCategoryFailure(error.message));
        }
      });
  };
};

export const getFaqArticleSubCategory = (params) => {
  return async (dispatch) => {
    dispatch(getFaqArticleSubCategoryLoading());
    await getFaqArticleFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqArticleSubCategorySuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqArticleSubCategoryFailure(error.message));
        }
      });
  };
};

export const getFaqArticleList = (params) => {
  return async (dispatch) => {
    dispatch(getFaqArticleListLoading());
    await getFaqArticleListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqArticleListSuccess(response?.data?.data));
          dispatch(clearFaqArticleListResponse());
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqArticleListFailure(error.response?.data?.message));
        }
      });
  };
};



export const getFaqQuestionEntityType = (params) => {
  return async (dispatch) => {
    dispatch(getFaqQuestionEntityTypeLoading());
    await getFaqQuestionKeywordsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqQuestionEntityTypeSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqQuestionEntityTypeFailure(error.message));
        }
      });
  };
};

export const getFaqQuestionKeywords = (params) => {
  return async (dispatch) => {
    dispatch(getFaqQuestionKeywordsLoading());
    await getFaqQuestionKeywordsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqQuestionKeywordsSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqQuestionKeywordsFailure(error.message));
        }
      });
  };
};

export const getFaqEditPageCommon = (params) => {
  return async (dispatch) => {
    dispatch(getFaqEditPageCommonLoading());
    await getFaqEditPageCommonRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqEditPageCommonSuccess(response?.data?.data));
          // dispatch(clearPostFaqGenerateAnswersResponse());
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqEditPageCommonFailure(error.message));
        }
      })
  };
};
export const postFaqMappedHeading = (data) => {
  return async (dispatch) => {
    dispatch(postFaqMappedHeadingLoading());

    await postFaqGenerateCommonRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqMappedHeadingSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (axios.isCancel(error) || (error && error.response)) {
          dispatch(postFaqMappedHeadingFailure(error.message));
        }
      });
  };
};

export const deleteFaqQuestionAndMapping = (params) => {
  return async (dispatch) => {
    dispatch(deleteFaqQuestionAndMappingLoading());

    await deleteFaqQuestionAndMappingRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status < 300) {
          dispatch(deleteFaqQuestionAndMappingSuccess("Deleted Successfully"));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(deleteFaqQuestionAndMappingFailure(error.message));
        }
      }).finally(() => {
        setTimeout(() => {
          dispatch(clearDeleteFaqQuestionAndMappingResponse());
        }, 3000);
      });
  };
};

export const postFaqEditPageCommon = (data) => {
  return async (dispatch) => {
    dispatch(postFaqPageCommonLoading());
    await postFaqEditPageCommonRepo(data)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(postFaqPageCommonSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postFaqPageCommonFailure(error.message.message));
        }
      }).finally(() => {
        setTimeout(() => {
          dispatch(clearPostFaqPageCommonSuccess())
        }, 3000)
      })
      ;
  };
};
// AI FAQ EXAM PANEL
export const getFaqExamName = (params) => {
  return async (dispatch) => {
    dispatch(getFaqExamNameLoading());
    await getFaqExamFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqExamNameSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqExamNameFailure(error.message));
        }
      });
  };
};
export const getFaqExamDomain = (params) => {
  return async (dispatch) => {
    dispatch(getFaqExamDomainLoading());
    await getFaqExamFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqExamDomainSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqExamDomainFailure(error.message));
        }
      });
  };
};

export const getFaqExamLevel = (params) => {
  return async (dispatch) => {
    dispatch(getFaqExamLevelLoading());
    await getFaqExamFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqExamLevelSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqExamLevelFailure(error.message));
        }
      });
  };
};

export const getFaqExamList = (params) => {
  return async (dispatch) => {
    dispatch(getFaqExamListLoading());
    await getFaqExamListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqExamListSuccess(response?.data));
          dispatch(clearFaqExamListSuccessResponse());
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqExamListFailure(error.response?.data?.message));
        }
      });
  };
};

export const getFaqCollegeFacetList = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeFacetListLoading());
    await getFaqCollegeFacetListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeFacetListSuccess(response?.data));
          dispatch(clearFaqCollegeFacetListSuccessResponse());
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeFacetListFailure(error.response?.data?.message));
        }
      });
  };
};

export const getFaqCollegeFacetDomainFilter = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeFacetDomainFilterLoading());
    await getFaqCollegeFacetFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeFacetDomainFilterSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeFacetDomainFilterFailure(error.message));
        }
      });
  };
};

export const getFaqCollegeFacetH1TitleFilter = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeFacetH1TitleFilterLoading());
    await getFaqCollegeFacetFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeFacetH1TitleFilterSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeFacetH1TitleFilterFailure(error.message));
        }
      });
  };
};

export const getFaqCollegeFacetPageUrlFilter = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeFacetPageUrlFilterLoading());
    await getFaqCollegeFacetFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeFacetPageUrlFilterSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeFacetPageUrlFilterFailure(error.message));
        }
      });
  };
};

export const postFaqGenerateHeading = (data, controller) => {
  return async (dispatch) => {
    dispatch(postFaqGenerateHeadingLoading());

    await postFaqGenerateCommonRepo(data, controller?.signal) // Pass signal for aborting
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqGenerateHeadingSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (axios.isCancel(error) || (error && error.response)) {
          dispatch(postFaqGenerateHeadingFailure(error.response));
        }
      });
  };
};

export const postFaqGenerateQuestions = (data, controller) => {
  return async (dispatch) => {
    dispatch(postFaqGenerateQuestionLoading());

    await postFaqGenerateCommonRepo(data, controller?.signal) // Pass signal to axios
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqGenerateQuestionSuccess(response?.data));
        }
      })
      .catch((error) => {
        // api cancellation
        if (axios.isCancel(error) || (error && error.response)) {
          dispatch(postFaqGenerateQuestionFailure(error.response));
        }
      });
  };
};

export const postFaqGenerateAnswers = (data, controller) => {
  return async (dispatch) => {
    dispatch(postFaqGenerateAnswersLoading());

    await postFaqGenerateCommonRepo(data, controller?.signal) // Pass signal for aborting
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqGenerateAnswersSuccess(response?.data));
          dispatch(clearPostFaqGenerateAnswersErrorResponse());
        }
      })
      .catch((error) => {
        if (axios.isCancel(error) || (error && error.response)) {
          dispatch(postFaqGenerateAnswersFailure(error.response));
        }
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(clearPostFaqGenerateQuestionResponse());
          // dispatch(clearPostFaqGenerateAnswersResponse());
        }, 3000)
      });
  };
};

export const postFaqRegenerateQuestion = (data) => {
  return async (dispatch) => {
    dispatch(postFaqRegenerateQuestionLoading());
    await postFaqGenerateCommonRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqRegenerateQuestionSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postFaqRegenerateQuestionFailure(error.response));
        }
      });
  };
};

export const postFaqRegenerateAnswers = (data) => {
  return async (dispatch) => {
    dispatch(postFaqRegenerateAnswersLoading());
    await postFaqGenerateCommonRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqRegenerateAnswersSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postFaqRegenerateAnswersFailure(error.response));
        }
      });
  };
};

export const postFaqGenerateAnswerModification = (data) => {
  return async (dispatch) => {
    dispatch(postFaqGenerateAnswerModificationLoading());
    await postFaqGenerateCommonRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqGenerateAnswerModificationSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postFaqGenerateAnswerModificationFailure(error.response));
        }
      });
  };
};


export const postFaqEntityLock = (data) => {
  return async (dispatch) => {
    dispatch(postFaqEntityLockLoading());
    await postFaqEntityLockRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postFaqEntityLockSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postFaqEntityLockFailure(error.message));
        }
      });
  };
};

export const getFaqCollegeName = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeNameLoading());
    await getFaqCollegeFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeNameSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeNameFailure(error.message));
        }
      });
  };
};

export const getFaqCollegePageType = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegePageTypeLoading());
    await getFaqCollegeFilterRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegePageTypeSuccess(response?.data?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegePageTypeFailure(error.message));
        }
      });
  };
};

export const getFaqCollegeList = (params) => {
  return async (dispatch) => {
    dispatch(getFaqCollegeListLoading());
    await getFaqCollegeListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getFaqCollegeListSuccess(response?.data));
          dispatch(clearFaqCollegeListResponse());
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFaqCollegeListFailure(error.response?.data?.message));
        }
      });
  };
};

// clear cache action
export const postClearCache = (data) => {
  return async (dispatch) => {
    dispatch(postClearCacheLoading());
    await postClearCacheRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postClearCacheSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postClearCacheFailure(error.message));
        }
      });
  };
};

export default faqSlice.reducer;